import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  AppEventModel,
  AppEventType,
  HxCurrencyPipe,
  HxEventService,
  HxFioPipe,
  HxPaymentApprovalService,
  HxUiLabelPipe,
  PaymentApprovalModel,
  PaymentApprovalStatus
} from 'hx-services';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe, NgFor, NgIf } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
    selector: 'app-payment-approval-view',
    templateUrl: './payment-approval-view.component.html',
    styleUrls: ['./payment-approval-view.component.css'],
    encapsulation: ViewEncapsulation.None,
    imports: [NgIf, NgFor, DatePipe, TranslocoPipe, HxCurrencyPipe, HxFioPipe, HxUiLabelPipe]
})
export class PaymentApprovalViewComponent implements OnInit {
  @Input() id: number;
  paymentApproval: PaymentApprovalModel;
  isLoading = {
    form: false,
  };
  events: AppEventModel[] = [];
  statusOptions = new Map<PaymentApprovalStatus, { badge: string }>([
    [PaymentApprovalStatus.CREATED, {badge: 'info'}],
    [PaymentApprovalStatus.MODIFIED, {badge: 'brand'}],
    [PaymentApprovalStatus.SUCCEED, {badge: 'success'}],
    [PaymentApprovalStatus.CANCELLED, {badge: 'danger'}],
    [PaymentApprovalStatus.WAIT_PAYMENT, {badge: 'warning'}],
  ]);

  eventOptions = new Map<AppEventType, { badge: string }>([
    [AppEventType.PAYMENT_APPROVAL_CREATED, {badge: 'info'}],
    [AppEventType.PAYMENT_APPROVAL_MODIFIED, {badge: 'brand'}],
    [AppEventType.PAYMENT_APPROVAL_SUCCEED, {badge: 'success'}],
    [AppEventType.PAYMENT_APPROVAL_CANCELLED, {badge: 'danger'}],
    [AppEventType.PAYMENT_APPROVAL_WAIT_PAYMENT, {badge: 'warning'}],
  ]);

  constructor(
    private aRoute: ActivatedRoute,
    private paymentApprovalService: HxPaymentApprovalService,
    private eventService: HxEventService,
    public modal: NgbActiveModal,
  ) {}

  ngOnInit(): void {
    this.loadList();
    this.loadEvents();
  }

  dismissModal() {
    this.modal.dismiss();
  }

  private async loadList() {
    this.isLoading.form = true;
    try {
      this.paymentApproval = await this.paymentApprovalService.getPaymentApprovalById(this.id);
      this.paymentApproval.invoicePayments = this.paymentApproval.invoicePayments.filter(r => r.value > 0);
    } finally {
      this.isLoading.form = false;
    }
  }

  private loadEvents() {
    this.eventService.getPaymentApprovalEventList(this.id)
      .then(result => this.events = result, err => console.error(err));
  }
}
